<template>
  <div class="box" :class="{ imFullStyle: imFull }">
    <div class="title">
      <div class="title_left">
        <img src="@/assets/image/logo_1.png" class="logo" alt="" />
        <p>在线法律咨询</p>
      </div>
      <div class="title_right" >
        <div class="state">
          <img class="state_img" @click="toService" src="@/assets/image/zixun/serviceState0.webp" alt="" v-if="serviceState.key === 0" />
          <img class="state_img" @click="toService" src="@/assets/image/zixun/serviceState1.webp" alt="" v-if="serviceState.key === 1"/>
          <img class="state_img" @click="toService" src="@/assets/image/zixun/serviceState2.webp" alt="" v-if="serviceState.key === 2"/>
        </div>
        <img v-if="imFull" src="@/assets/image/home/home_icon2.webp" class="img" alt="" @click="fullClick"/>
        <img v-else src="@/assets/image/home/home_icon1.webp" class="img" alt="" @click="fullClick"/>
        <p @click="fullClick">{{ imFull ? "收起" : "展开" }}</p>
      </div>
    </div>
    <div class="iframeBox" v-show="!loading">
      <img src="@/assets/image/home/im/im_t.png" class="im_t" alt="" />
      <img src="@/assets/image/home/im/im_b.png" class="im_b" alt="" />
      <img src="@/assets/image/home/im/im_l.png" class="im_l" alt="" />
      <img src="@/assets/image/home/im/im_r.png" class="im_r" alt="" />
      <img src="@/assets/image/home/im/im_t_l.png" class="im_t_l" alt="" />
      <img src="@/assets/image/home/im/im_t_r.png" class="im_t_r" alt="" />
      <img src="@/assets/image/home/im/im_b_l.png" class="im_b_l" alt="" />
      <img src="@/assets/image/home/im/im_b_r.png" class="im_b_r" alt="" />
      <!-- <img src="@/assets/image/home/im/im_btn_l.png" class="im_btn_l" alt="" />
      <img src="@/assets/image/home/im/im_btn_r.png" class="im_btn_r" alt="" /> -->
      <iframe class="iframeStyle" :src="url" frameborder="0" @load="onLoad"></iframe>
    </div>
    <el-skeleton
      :throttle="500"
      v-show="loading"
      style="height: 450px; padding: 20px"
      :rows="10"
      animated
    />
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import userinfo  from "@/mixins/userinfo";
export default {
  name: "my-consultation",
  mixins: [userinfo],
  data() {
    return {
      loading: true,
    };
  },
  mounted() {
    // 防止 iframe 卡死加载，5 秒后自动去掉 loading
    this.loading = true;
    this.timer = setTimeout(() => {
      if (this.loading) {
        this.loading = false;
      }
    }, 5000);
  },
  computed: {
    ...mapState("customerService", ["url", "imFull"]),
  },
  methods: {
    ...mapActions("customerService", ["setImFull"]),
    onLoad() {
      this.loading = false;
    },
    fullClick() {
      this.setImFull(!this.imFull);
    },
   async toService(){
    await this.verifyUserAuth()
      this.$router.push({
        path: "/accountCenter/advisory",
        query: {
          buy: 1
        }
      })
    }
  },
  beforeUnmount() {
    clearTimeout(this.timer);
  },
};
</script>

<style scoped lang="scss">
.box {
  width: 100%;
  height: 506px;
  border-radius: $border-radius;
  background: #f6f9fd;
  transition: height 0.3s ease; // ✅ 默认加 transition
  .title {
    height: 56px;
    width: 100%;
    @include flex-s;
    padding: 0 $padding-md;
    width: 100%;
    background-image: url(~@/assets/image/home/im/im_title_bg.png);
    background-size: 100% ;
    background-repeat: no-repeat;

    &_left {
      @include flex-c;
      font-size: $font-size-md;
      color: $font-j-1;

      .logo {
        width: 17px;
        height: 17px;
        margin-right: 6px;
      }
    }

    &_right {
      @include flex-c;

      font-family: "Noto Sans SC";
      font-size: $font-size-sm;
      color: $primary-color;
      cursor: pointer;

      .img {
        width: 14px;
        height: 14px;
        margin-right: 6px;
      }
      .state{
        margin-right: 20px;
       
        &_img{
           width: 126px;
       height: auto;
        }
      }
    }
  }

  .iframeBox {
    height: 450px;
    position: relative;
    overflow: hidden;
    border-radius: 0 0 $border-radius $border-radius;
    transition: height 0.3s ease; // ✅ 默认加 transition
    .iframeStyle {
      transition: height 0.3s ease; // ✅ 默认加 transition
      width: 100%;
      height: 500px;
      position: absolute;
      top: -50px;
    }

    .im_t {
      width: 100%;
      height: 21px;
      position: absolute;
      bottom: 134px;
      left: 0px;
      z-index: 2;
    }

    .im_b {
      width: 100%;
      height: 10px;
      position: absolute;
      bottom: 0px;
      left: 0px;
      z-index: 2;
    }

    .im_l {
      height: 124px;
      position: absolute;
      bottom: 10px;
      left: 0px;
      z-index: 2;
    }

    .im_r {
      height: 124px;
      position: absolute;
      bottom: 10px;
      right: 0px;
      z-index: 2;
    }
    .im_t_l,
    .im_t_r,
    .im_b_l,
    .im_b_r {
      z-index: 3;
      position: absolute;
      width: 10px;
    }
    .im_t_l,
    .im_t_r {
      height: 21px;
      bottom: 134px;
    }
    .im_t_l,
    .im_b_l {
      left: 0;
    }
    .im_t_r,
    .im_b_r {
      right: 0;
    }
    .im_b_l,
    .im_b_r {
      height: 10px;
      bottom: 0px;
    }
    .im_btn_l {
      width: 14px;
      height: 28px;
      position: absolute;
      bottom: 16px;
      right: 66px;
      z-index: 2;
    }

    .im_btn_r {
      width: 14px;
      height: 28px;
      position: absolute;
      bottom: 16px;
      right: 16px;
      z-index: 2;
    }
  }
}

.imFullStyle {
  height: 806px;

  .iframeBox {
    height: 750px;

    .iframeStyle {
      height: 800px;
    }
  }
}
</style>
